import { useAppSelector } from "../hooks";

export const useGetProfile = () => {
  const { data, status } = useAppSelector(
    ({ readerStatistics }) => readerStatistics.profile
  );

  return {
    data,
    status,
  };
};

export const useGetUser = () => {
  const { data, status } = useAppSelector(
    ({ readerStatistics }) => readerStatistics.user
  );

  return {
    data,
    status,
  };
};

export const useTopConsumedCategories = () => {
  const { data, status } = useAppSelector(
    ({ readerStatistics }) => readerStatistics.topConsumedCategories
  );

  return {
    data,
    status,
  };
};

export const useProfileStreakStats = () => {
  const { data, status } = useAppSelector(
    ({ readerStatistics }) => readerStatistics.profileStreakStats
  );

  return {
    data,
    status,
  };
};

export const useStreakDays = () => {
  const { data, status } = useAppSelector(
    ({ readerStatistics }) => readerStatistics.streakDays
  );

  return {
    data,
    status,
  };
};
